import { render, staticRenderFns } from "./AccountDayChat.vue?vue&type=template&id=1e2caa96&scoped=true"
import script from "./AccountDayChat.vue?vue&type=script&lang=js"
export * from "./AccountDayChat.vue?vue&type=script&lang=js"
import style0 from "./AccountDayChat.vue?vue&type=style&index=0&id=1e2caa96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2caa96",
  null
  
)

export default component.exports